<div class="mb-1" *ngIf="superAdmin || orgAdmin">
    <app-company-selector (selected)="companySelected($event)"></app-company-selector>
</div>
<div class="container py-4" *ngIf="this.apiCompanyId">

    <div class="card mb-3" *ngIf="currentDocumentId != 0">
        <div class="card-body">
            <h4 class="card-title">Workflow</h4>
            <div class="mb-3 d-flex justify-content-between align-items-center">
                Correspondence
                <button class="btn btn-primary" (click)="sendCorrespondence(content)">Send</button>
            </div>
            <hr />
            <div class="mb-3 d-flex justify-content-between align-items-center">
                Workflow
                <div>

                    <button class="btn btn-primary me-2" (click)="viewCorrespondence()">{{ showCorrespondence ? 'Hide': 'View'}}</button>
                    <button class="btn btn-primary" [disabled] (click)="exportCorrespondence()">Export</button>
                </div>


            </div>
            <div *ngIf="showCorrespondence">
                <table class="table table-bordered bg-white table-sm company-acts-table table-hover">
                    <tr>
                        <th>DATE/TIME</th>
                        <th>NAME</th>
                        <th>EMAIL</th>
                        <th>SENDER</th>
                        <th>TYPE</th>
                        <th>DOCUMENT</th>
                        <th>ATTACHMENTS</th>
                    </tr>
                    <tr *ngFor="let item of correspondence">
                        <td>{{item.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.sender}}</td>
                        <td>{{item.documentCorrespondenceType}}</td>

                        <td class="text-center"><a href="#" (click)="download($event, item.id)"
                                class="d-flex align-items-center"><span class="icon icon-view-red me-2"></span></a></td>
                        <td class="text-center">
                            <div class="d-flex">
                                <a href="#" *ngFor="let attachment of item.attachments"
                                    (click)="downloadAttachment($event, attachment.id, item.id)"
                                    class="d-flex align-items-center">
                                    <span class="icon icon-view-red me-1"></span>
                                </a>
                            </div>
                        </td>
                    </tr>
                </table>

            </div>
        </div>
    </div>

    <div class="text-end mb-2"><button class="btn btn-primary" (click)="print()">Export</button></div>
    <form id="mainForm" [formGroup]="mainForm" (ngSubmit)="submit()">


        <div class="card mb-3" *ngIf="currentDocumentId == 0">
            <div class="card-body">
                <h4 class="card-title">Request Form</h4>




                <div class="mb-3">
                    <label for="documentFileData" class="form-label"
                        [class.is-invalid]="mainForm.controls.documentFileData.touched && mainForm.controls.documentFileData.invalid">Request
                        Form</label>
                    <input type="file" class="form-control" id="documentFileData" formControlName="documentFileData"
                        [class.is-invalid]="mainForm.controls.documentFileData.touched && mainForm.controls.documentFileData.invalid"
                        (change)="fileUpload(mainForm.controls.documentFileData, $event)">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.documentFileData.errors">
                        <div *ngIf="mainForm.controls.documentFileData.errors.required">Required</div>
                    </div>


                </div>





            </div>
        </div>

        <div class="card mb-3" *ngIf="currentDocumentId > 0">
            <div class="card-body">
                <h4 class="card-title">Request Form</h4>

                <div class="mb-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <label for="documentFileData" class="form-label"
                            [class.is-invalid]="mainForm.controls.documentFileData.touched && mainForm.controls.documentFileData.invalid">Update
                            Request Form</label>
                    </div>

                    <div *ngIf="currentDocument?.documentFilePath" class="mb-2">

                        

                        <div class="d-flex align-items-center">
                            <button *ngIf="currentDocument.documentFilePath" type="button"
                                (click)="downloadDocumentFile($event, 'Document')"
                                class="btn btn-link d-flex justify-content-between align-items-center me-2"><span
                                    class="icon icon-view-red"></span>&nbsp;DOWNLOAD CURRENT</button>
                            <button type="button" class="btn btn-primary me-2" [disabled]="!currentDocument.documentHistory || currentDocument.documentHistory.length == 0"
                                (click)="showHistory = !showHistory; showDocumentUpload = false;">{{showHistory
                                ? 'HIDE' : 'SHOW'}} History</button>
                            <button *ngIf="!showDocumentUpload" type="button" class="btn btn-primary"
                                (click)="showDocumentUpload = true; showHistory = false;">Upload new</button>
                            <button *ngIf="showDocumentUpload" type="button" class=" btn btn-primary"
                                (click)="showDocumentUpload = false;">Cancel</button>

                        </div>
                        
                        <div *ngIf="showHistory" class="mb-2">
                            <button *ngFor="let doc of currentDocument.documentHistory" type="button"
                                (click)="downloadDocumentHistoryFile($event, doc.id)"
                                class="btn btn-link d-flex justify-content-between align-items-center"><span
                                    class="icon icon-view-red"></span>&nbsp;{{doc.createdAt | date:'yyyy-MM-dd HH:mm:ss'
                                }}</button>
                        </div>

                        <div class="mb-2">
                            
                        </div>
                        
                        <div *ngIf="!currentDocument?.documentFilePath || showDocumentUpload" class="mb-2">
                            <input type="file" class="form-control" id="documentFileData"
                                formControlName="documentFileData"
                                [class.is-invalid]="mainForm.controls.documentFileData.touched && mainForm.controls.documentFileData.invalid"
                                (change)="fileUpload(mainForm.controls.documentFileData, $event)">
                            <div class="invalid-feedback text-end" *ngIf="mainForm.controls.documentFileData.errors">
                                <div *ngIf="mainForm.controls.documentFileData.errors.required">Required</div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>



        <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Accountable recipient of the request</h4>

                <div class="mb-3">
                    <label for="recipientFirstname" class="form-label"
                        [class.is-invalid]="mainForm.controls.recipientFirstname.touched && mainForm.controls.recipientFirstname.invalid">First
                        Name</label>
                    <input type="text" class="form-control" id="recipientFirstname" formControlName="recipientFirstname"
                        [class.is-invalid]="mainForm.controls.recipientFirstname.touched && mainForm.controls.recipientFirstname.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.recipientFirstname.errors">
                        <div *ngIf="mainForm.controls.recipientFirstname.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="recipientLastname" class="form-label"
                        [class.is-invalid]="mainForm.controls.recipientLastname.touched && mainForm.controls.recipientLastname.invalid">Last
                        Name</label>
                    <input type="text" class="form-control" id="recipientLastname" formControlName="recipientLastname"
                        [class.is-invalid]="mainForm.controls.recipientLastname.touched && mainForm.controls.recipientLastname.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.recipientLastname.errors">
                        <div *ngIf="mainForm.controls.recipientLastname.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="recipientContactNumber" class="form-label"
                        [class.is-invalid]="mainForm.controls.recipientContactNumber.touched && mainForm.controls.recipientContactNumber.invalid">Contact
                        Number</label>
                    <input type="text" class="form-control" id="recipientContactNumber"
                        formControlName="recipientContactNumber"
                        [class.is-invalid]="mainForm.controls.recipientContactNumber.touched && mainForm.controls.recipientContactNumber.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.recipientContactNumber.errors">
                        <div *ngIf="mainForm.controls.recipientContactNumber.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="recipientEmail" class="form-label"
                        [class.is-invalid]="mainForm.controls.recipientEmail.touched && mainForm.controls.recipientEmail.invalid">Email</label>
                    <input type="text" class="form-control" id="recipientEmail" formControlName="recipientEmail"
                        [class.is-invalid]="mainForm.controls.recipientEmail.touched && mainForm.controls.recipientEmail.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.recipientEmail.errors">
                        <div *ngIf="mainForm.controls.recipientEmail.errors.required">Required</div>
                        <div *ngIf="mainForm.controls.recipientEmail.errors.email">Invalid</div>
                    </div>
                </div>

            </div>
        </div>

        <!-- <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Applicable facility or department</h4>

                <div class="mb-3">
                    <label for="documentRegionId" class="form-label">Region</label>
                    <ng-select [items]="regions" bindLabel="name" bindValue="id" id="documentRegionId"
                        formControlName="documentRegionId" placeholder="Select a region" [clearable]="false"
                        [class.is-invalid]="mainForm.controls.documentRegionId.touched && mainForm.controls.documentRegionId.invalid"></ng-select>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.documentRegionId.errors">
                        <div *ngIf="mainForm.controls.documentRegionId.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="documentFacilityId" class="form-label">Facility</label>
                    <ng-select [items]="facilities" bindLabel="name" bindValue="id" id="documentFacilityId"
                        formControlName="documentFacilityId" placeholder="Select a facility" [clearable]="false"
                        [readonly]="facilities == undefined"
                        [class.is-invalid]="mainForm.controls.documentFacilityId.touched && mainForm.controls.documentFacilityId.invalid"></ng-select>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.documentFacilityId.errors">
                        <div *ngIf="mainForm.controls.documentFacilityId.errors.required">Required</div>
                    </div>
                </div>

            </div>
        </div> -->

        <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Request Details</h4>


                <div class="mb-3">
                    <label for="receivedDate" class="form-label"
                        [class.is-invalid]="mainForm.controls.receivedDate.touched && mainForm.controls.receivedDate.invalid">Date
                        Request was Received</label>
                    <input type="date" class="form-control" id="receivedDate" formControlName="receivedDate"
                        [class.is-invalid]="mainForm.controls.receivedDate.touched && mainForm.controls.receivedDate.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.receivedDate.errors">
                        <div *ngIf="mainForm.controls.receivedDate.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="acknowledgedDate" class="form-label"
                        [class.is-invalid]="mainForm.controls.acknowledgedDate.touched && mainForm.controls.acknowledgedDate.invalid">Date
                        Request was Acknowledged</label>
                    <input type="date" class="form-control" id="acknowledgedDate" formControlName="acknowledgedDate"
                        [class.is-invalid]="mainForm.controls.acknowledgedDate.touched && mainForm.controls.acknowledgedDate.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.acknowledgedDate.errors">
                        <div *ngIf="mainForm.controls.acknowledgedDate.errors.required">Required</div>
                    </div>
                </div>

                <h5>Data Subject (The person/company the information relates to)</h5>

                <div class="mb-3">
                    <label for="subjectIDNumber" class="form-label"
                        [class.is-invalid]="mainForm.controls.subjectIDNumber.touched && mainForm.controls.subjectIDNumber.invalid">ID
                        Number / Company Registration Number</label>
                    <input type="text" class="form-control" id="subjectIDNumber" formControlName="subjectIDNumber"
                        [class.is-invalid]="mainForm.controls.subjectIDNumber.touched && mainForm.controls.subjectIDNumber.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.subjectIDNumber.errors">
                        <div *ngIf="mainForm.controls.subjectIDNumber.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="subjectName" class="form-label"
                        [class.is-invalid]="mainForm.controls.subjectName.touched && mainForm.controls.subjectName.invalid">Name
                        & Surname / Company Name</label>
                    <input type="text" class="form-control" id="subjectName" formControlName="subjectName"
                        [class.is-invalid]="mainForm.controls.subjectName.touched && mainForm.controls.subjectName.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.subjectName.errors">
                        <div *ngIf="mainForm.controls.subjectName.errors.required">Required</div>
                    </div>
                </div>


                <hr />

                <h5>Requestor</h5>

                <div class="mb-3">
                    <label for="requestorIDNumber" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestorIDNumber.touched && mainForm.controls.requestorIDNumber.invalid">ID
                        Number</label>
                    <input type="text" class="form-control" id="requestorIDNumber" formControlName="requestorIDNumber"
                        [class.is-invalid]="mainForm.controls.requestorIDNumber.touched && mainForm.controls.requestorIDNumber.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestorIDNumber.errors">
                        <div *ngIf="mainForm.controls.requestorIDNumber.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="requestorFirstname" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestorFirstname.touched && mainForm.controls.requestorFirstname.invalid">First
                        Name</label>
                    <input type="text" class="form-control" id="requestorFirstname" formControlName="requestorFirstname"
                        [class.is-invalid]="mainForm.controls.requestorFirstname.touched && mainForm.controls.requestorFirstname.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestorFirstname.errors">
                        <div *ngIf="mainForm.controls.requestorFirstname.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="requestorLastname" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestorLastname.touched && mainForm.controls.requestorLastname.invalid">Last
                        Name</label>
                    <input type="text" class="form-control" id="requestorLastname" formControlName="requestorLastname"
                        [class.is-invalid]="mainForm.controls.requestorLastname.touched && mainForm.controls.requestorLastname.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestorLastname.errors">
                        <div *ngIf="mainForm.controls.requestorLastname.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="requestorCompanyRegistrationNumber" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestorCompanyRegistrationNumber.touched && mainForm.controls.requestorCompanyRegistrationNumber.invalid">Company
                        Registration
                        Number</label>
                    <input type="text" class="form-control" id="requestorCompanyRegistrationNumber"
                        formControlName="requestorCompanyRegistrationNumber"
                        [class.is-invalid]="mainForm.controls.requestorCompanyRegistrationNumber.touched && mainForm.controls.requestorCompanyRegistrationNumber.invalid">
                    <div class="invalid-feedback text-end"
                        *ngIf="mainForm.controls.requestorCompanyRegistrationNumber.errors">
                        <div *ngIf="mainForm.controls.requestorCompanyRegistrationNumber.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="requestorCompany" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestorCompany.touched && mainForm.controls.requestorCompany.invalid">Company
                        Name</label>
                    <input type="text" class="form-control" id="requestorCompany" formControlName="requestorCompany"
                        [class.is-invalid]="mainForm.controls.requestorCompany.touched && mainForm.controls.requestorCompany.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestorCompany.errors">
                        <div *ngIf="mainForm.controls.requestorCompany.errors.required">Required</div>
                    </div>
                </div>



                <div class="mb-3">
                    <label for="requestorAddress" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestorAddress.touched && mainForm.controls.requestorAddress.invalid">Address</label>
                    <textarea type="text" class="form-control" id="requestorAddress" formControlName="requestorAddress"
                        [class.is-invalid]="mainForm.controls.requestorAddress.touched && mainForm.controls.requestorAddress.invalid"></textarea>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestorAddress.errors">
                        <div *ngIf="mainForm.controls.requestorAddress.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="requestorEmail" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestorEmail.touched && mainForm.controls.requestorEmail.invalid">Email</label>
                    <input type="text" class="form-control" id="requestorEmail" formControlName="requestorEmail"
                        [class.is-invalid]="mainForm.controls.requestorEmail.touched && mainForm.controls.requestorEmail.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestorEmail.errors">
                        <div *ngIf="mainForm.controls.requestorEmail.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="requestorContactNumber" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestorContactNumber.touched && mainForm.controls.requestorContactNumber.invalid">Contact
                        Number</label>
                    <input type="text" class="form-control" id="requestorContactNumber"
                        formControlName="requestorContactNumber"
                        [class.is-invalid]="mainForm.controls.requestorContactNumber.touched && mainForm.controls.requestorContactNumber.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestorContactNumber.errors">
                        <div *ngIf="mainForm.controls.requestorContactNumber.errors.required">Required</div>
                    </div>
                </div>

                <hr />

                <h5>Details of PAIA Request</h5>

                <div class="mb-3">
                    <label for="requestTypeDropDown" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestTypeDropDown.touched && mainForm.controls.requestTypeDropDown.invalid">Type
                        of Request</label>
                    <ng-select id="requestTypeDropDown" formControlName="requestTypeDropDown"
                        placeholder="Select the type of request" [clearable]="false" [items]="requestTypes"
                        [class.is-invalid]="mainForm.controls.requestTypeDropDown.touched && mainForm.controls.requestTypeDropDown.invalid">
                    </ng-select>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestTypeDropDown.errors">
                        <div *ngIf="mainForm.controls.requestTypeDropDown.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3" [class.d-none]="mainForm.controls.requestTypeDropDown.value != 'Other request'">
                    <label for="requestType" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestType.touched && mainForm.controls.requestType.invalid">Type
                        of request details</label>
                    <input type="text" class="form-control" id="requestType" formControlName="requestType"
                        [class.is-invalid]="mainForm.controls.requestType.touched && mainForm.controls.requestType.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestType.errors">
                        <div *ngIf="mainForm.controls.requestType.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="requestDetails" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestDetails.touched && mainForm.controls.requestDetails.invalid">Describe
                        what information and records are
                        required</label>
                    <textarea type="text" class="form-control" id="requestDetails" formControlName="requestDetails"
                        [class.is-invalid]="mainForm.controls.requestDetails.touched && mainForm.controls.requestDetails.invalid"></textarea>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestDetails.errors">
                        <div *ngIf="mainForm.controls.requestDetails.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="requestReason" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestReason.touched && mainForm.controls.requestReason.invalid">Describe
                        the reasons why the information and records
                        have been requested</label>
                    <textarea type="text" class="form-control" id="requestReason" formControlName="requestReason"
                        [class.is-invalid]="mainForm.controls.requestReason.touched && mainForm.controls.requestReason.invalid"></textarea>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestReason.errors">
                        <div *ngIf="mainForm.controls.requestReason.errors.required">Required</div>
                    </div>
                </div>

                <hr />

                <div class="mb-3">
                    <label for="incidentDate" class="form-label"
                        [class.is-invalid]="mainForm.controls.incidentDate.touched && mainForm.controls.incidentDate.invalid">Date
                        of the incident/admission to which the request
                        relates</label>
                    <input type="date" class="form-control" id="incidentDate" formControlName="incidentDate"
                        [class.is-invalid]="mainForm.controls.incidentDate.touched && mainForm.controls.incidentDate.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.incidentDate.errors">
                        <div *ngIf="mainForm.controls.incidentDate.errors.required">Required</div>
                    </div>
                </div>

            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Disbursements</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Rate</th>
                            <th>Quantity</th>
                            <th>Total</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container formArrayName="paiaDocumentDisbursements">
                            <ng-container
                                *ngFor="let paiaDocumentDisbursementForm of mainForm.controls.paiaDocumentDisbursements.controls; let i = index">

                                <tr [formGroup]="paiaDocumentDisbursementForm" class="mb-2">
                                    <td>
                                        <input type="date" class="form-control" id="date" formControlName="date"
                                            [class.is-invalid]="paiaDocumentDisbursementForm.controls.date.touched && paiaDocumentDisbursementForm.controls.date.invalid"
                                            placeholder="Date">
                                        <div class="invalid-feedback text-end"
                                            *ngIf="paiaDocumentDisbursementForm.controls.date.errors">
                                            <div *ngIf="paiaDocumentDisbursementForm.controls.date.errors.required">
                                                Required</div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" id="description"
                                            formControlName="description"
                                            [class.is-invalid]="paiaDocumentDisbursementForm.controls.description.touched && paiaDocumentDisbursementForm.controls.description.invalid"
                                            placeholder="Description">
                                        <div class="invalid-feedback text-end"
                                            *ngIf="paiaDocumentDisbursementForm.controls.description.errors">
                                            <div
                                                *ngIf="paiaDocumentDisbursementForm.controls.description.errors.required">
                                                Required</div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" id="rate" formControlName="rate"
                                            [class.is-invalid]="paiaDocumentDisbursementForm.controls.rate.touched && paiaDocumentDisbursementForm.controls.rate.invalid"
                                            placeholder="Rate">
                                        <div class="invalid-feedback text-end"
                                            *ngIf="paiaDocumentDisbursementForm.controls.rate.errors">
                                            <div *ngIf="paiaDocumentDisbursementForm.controls.rate.errors.required">
                                                Required</div>
                                            <div *ngIf="paiaDocumentDisbursementForm.controls.rate.errors.min">
                                                Invalid</div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" id="quantity" formControlName="quantity"
                                            [class.is-invalid]="paiaDocumentDisbursementForm.controls.quantity.touched && paiaDocumentDisbursementForm.controls.quantity.invalid"
                                            placeholder="Quantity">
                                        <div class="invalid-feedback text-end"
                                            *ngIf="paiaDocumentDisbursementForm.controls.quantity.errors">
                                            <div *ngIf="paiaDocumentDisbursementForm.controls.quantity.errors.required">
                                                Required</div>
                                            <div *ngIf="paiaDocumentDisbursementForm.controls.quantity.errors.min">
                                                Invalid</div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" readonly placeholder="Total"
                                            [value]="paiaDocumentDisbursementForm.controls.quantity.value * paiaDocumentDisbursementForm.controls.rate.value" />
                                    </td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-link" (click)="removeDisbursement(i)">X</button>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>

                    </tbody>
                </table>
                <div class="text-end">
                    <button type="button" class="btn btn-default" (click)="addDisbursement()">Add</button>&nbsp;

                </div>


            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Status of request</h4>

                <div class="mb-3">
                    <label for="paiaDocumentStatusId" class="form-label"
                        [class.is-invalid]="mainForm.controls.paiaDocumentStatusId.touched && mainForm.controls.paiaDocumentStatusId.invalid">What
                        is the current status of the
                        request</label>
                    <ng-select [items]="statuses" bindLabel="name" bindValue="id" id="paiaDocumentStatusId"
                        formControlName="paiaDocumentStatusId" placeholder="Select a request status" [clearable]="false"
                        [class.is-invalid]="mainForm.controls.paiaDocumentStatusId.touched && mainForm.controls.paiaDocumentStatusId.invalid"></ng-select>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.paiaDocumentStatusId.errors">
                        <div *ngIf="mainForm.controls.paiaDocumentStatusId.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="extension" class="form-label"
                        [class.is-invalid]="mainForm.controls.extension.touched && mainForm.controls.extension.invalid">Please
                        indicate if extension beyond 30 days for provision
                        of the documents</label>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="extension" id="extensionYes"
                                [value]="true" formControlName="extension"
                                [class.is-invalid]="mainForm.controls.extension.touched && mainForm.controls.extension.invalid">
                            <label class="form-check-label" for="extensionYes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="extension" id="extensionNo"
                                [value]="false" formControlName="extension"
                                [class.is-invalid]="mainForm.controls.extension.touched && mainForm.controls.extension.invalid">
                            <label class="form-check-label" for="extensionNo">No</label>
                        </div>
                    </div>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.extension.errors">
                        <div *ngIf="mainForm.controls.extension.errors.required">Required</div>
                    </div>
                </div>

            </div>
        </div>


        <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Charges/ Fees</h4>

                <!-- <div class="mb-3">
                    <label for="requestFee" class="form-label"
                        [class.is-invalid]="mainForm.controls.requestFee.touched && mainForm.controls.requestFee.invalid">Request
                        Fee</label>
                    <input type="text" class="form-control" id="requestFee" formControlName="requestFee"
                        [class.is-invalid]="mainForm.controls.requestFee.touched && mainForm.controls.requestFee.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.requestFee.errors">
                        <div *ngIf="mainForm.controls.requestFee.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="noRequestFee" class="form-label"
                        [class.is-invalid]="mainForm.controls.noRequestFee.touched && mainForm.controls.noRequestFee.invalid">No
                        Request Fee</label>
                    <input type="text" class="form-control" id="noRequestFee" formControlName="noRequestFee"
                        [class.is-invalid]="mainForm.controls.noRequestFee.touched && mainForm.controls.noRequestFee.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.noRequestFee.errors">
                        <div *ngIf="mainForm.controls.noRequestFee.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="prepareReplyFee" class="form-label"
                        [class.is-invalid]="mainForm.controls.prepareReplyFee.touched && mainForm.controls.prepareReplyFee.invalid">Cost
                        to prepare reply</label>
                    <input type="text" class="form-control" id="prepareReplyFee" formControlName="prepareReplyFee"
                        [class.is-invalid]="mainForm.controls.prepareReplyFee.touched && mainForm.controls.prepareReplyFee.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.prepareReplyFee.errors">
                        <div *ngIf="mainForm.controls.prepareReplyFee.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="deposit" class="form-label"
                        [class.is-invalid]="mainForm.controls.deposit.touched && mainForm.controls.deposit.invalid">Deposit</label>
                    <input type="text" class="form-control" id="deposit" formControlName="deposit"
                        [class.is-invalid]="mainForm.controls.deposit.touched && mainForm.controls.deposit.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.deposit.errors">
                        <div *ngIf="mainForm.controls.deposit.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="amountBanked" class="form-label"
                        [class.is-invalid]="mainForm.controls.amountBanked.touched && mainForm.controls.amountBanked.invalid">Amount
                        to be banked</label>
                    <input type="text" class="form-control" id="amountBanked" formControlName="amountBanked"
                        [class.is-invalid]="mainForm.controls.amountBanked.touched && mainForm.controls.amountBanked.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.amountBanked.errors">
                        <div *ngIf="mainForm.controls.amountBanked.errors.required">Required</div>
                    </div>
                </div> -->


                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Number</th>
                            <th>Description</th>
                            <th>Tarriff</th>
                            <th>Item / Cost per Page or part thereof</th>
                            <th>Item / Number of Pages</th>
                            <th>Total</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container formArrayName="paiaDocumentFeeItems">
                            <ng-container
                                *ngFor="let paiaDocumentFeeItemsForm of mainForm.controls.paiaDocumentFeeItems.controls; let i = index">

                                <tr [formGroup]="paiaDocumentFeeItemsForm" class="mb-2">
                                    
                                    <td>
                                        {{i+1}}
                                    </td>
                                    <td>
                                        {{paiaDocumentFeeItemsForm.controls.description.value}}
                                        <input type="hidden" id="description" formControlName="description">
                                    </td>
                                    <td>
                                        {{paiaDocumentFeeItemsForm.controls.tarriff.value}}
                                        <input type="hidden" id="tarriff" formControlName="tarriff">
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" id="rate" formControlName="rate"
                                            [class.is-invalid]="paiaDocumentFeeItemsForm.controls.rate.touched && paiaDocumentFeeItemsForm.controls.rate.invalid"
                                            placeholder="Rate">
                                        <div class="invalid-feedback text-end"
                                            *ngIf="paiaDocumentFeeItemsForm.controls.rate.errors">
                                            <div *ngIf="paiaDocumentFeeItemsForm.controls.rate.errors.required">
                                                Required</div>
                                            <div *ngIf="paiaDocumentFeeItemsForm.controls.rate.errors.min">
                                                Invalid</div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" id="quantity" formControlName="quantity"
                                            [class.is-invalid]="paiaDocumentFeeItemsForm.controls.quantity.touched && paiaDocumentFeeItemsForm.controls.quantity.invalid"
                                            placeholder="Quantity">
                                        <div class="invalid-feedback text-end"
                                            *ngIf="paiaDocumentFeeItemsForm.controls.quantity.errors">
                                            <div *ngIf="paiaDocumentFeeItemsForm.controls.quantity.errors.required">
                                                Required</div>
                                            <div *ngIf="paiaDocumentFeeItemsForm.controls.quantity.errors.min">
                                                Invalid</div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" readonly placeholder="Total"
                                            [value]="paiaDocumentFeeItemsForm.controls.quantity.value * paiaDocumentFeeItemsForm.controls.rate.value" />
                                    </td>

                                    
                                </tr>
                            </ng-container>
                            <tr>
                                <td colspan="5">TOTAL COST</td>
                                <td>
                                    <input type="text" class="form-control" readonly placeholder="Total Cost"
                                            [value]="feeItemsTotal" />
                                </td>
                            </tr>
                        </ng-container>

                    </tbody>
                </table>

                <div class="mb-3">
                    <label for="feeComment" class="form-label"
                        [class.is-invalid]="mainForm.controls.feeComment.touched && mainForm.controls.feeComment.invalid">Comments on Fee Waived</label>
                    <input type="text" class="form-control" id="feeComment" formControlName="feeComment"
                        [class.is-invalid]="mainForm.controls.feeComment.touched && mainForm.controls.feeComment.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.feeComment.errors">
                        <div *ngIf="mainForm.controls.feeComment.errors.required">Required</div>
                    </div>
                </div>

                
            </div>
        </div>


        <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Response Outcome/ Decision</h4>

                <div class="mb-3">
                    <label for="decision" class="form-label"
                        [class.is-invalid]="mainForm.controls.decision.touched && mainForm.controls.decision.invalid">Outcome
                        of decision</label>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="decision" id="decisionApproved"
                                [value]="1" formControlName="decision"
                                [class.is-invalid]="mainForm.controls.decision.touched && mainForm.controls.decision.invalid">
                            <label class="form-check-label" for="decisionApproved">Approved</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="decision" id="decisionDeclined"
                                [value]="0" formControlName="decision"
                                [class.is-invalid]="mainForm.controls.decision.touched && mainForm.controls.decision.invalid">
                            <label class="form-check-label" for="decisionDeclined">Declined</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="decision" id="decisionPartially"
                                [value]="-1" formControlName="decision"
                                [class.is-invalid]="mainForm.controls.decision.touched && mainForm.controls.decision.invalid">
                            <label class="form-check-label" for="decisionPartially">Partially</label>
                        </div>

                    </div>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.decision.errors">
                        <div *ngIf="mainForm.controls.decision.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="decisionReason" class="form-label"
                        [class.is-invalid]="mainForm.controls.decisionReason.touched && mainForm.controls.decisionReason.invalid">Reason
                        for outcome</label>
                    <input type="text" class="form-control" id="decisionReason" formControlName="decisionReason"
                        [class.is-invalid]="mainForm.controls.decisionReason.touched && mainForm.controls.decisionReason.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.decisionReason.errors">
                        <div *ngIf="mainForm.controls.decisionReason.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="decisionDate" class="form-label"
                        [class.is-invalid]="mainForm.controls.decisionDate.touched && mainForm.controls.decisionDate.invalid">Date
                        of decision</label>
                    <input type="date" class="form-control" id="decisionDate" formControlName="decisionDate"
                        [class.is-invalid]="mainForm.controls.decisionDate.touched && mainForm.controls.decisionDate.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.decisionDate.errors">
                        <div *ngIf="mainForm.controls.decisionDate.errors.required">Required</div>
                    </div>
                </div>


                <div class="mb-3">
                    <label for="accessGranted" class="form-label"
                        [class.is-invalid]="mainForm.controls.accessGranted.touched && mainForm.controls.accessGranted.invalid">Request granted access in terms of Public interest  in terms of section 46 and 70 of PAIA?</label>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="accessGranted" id="accessGrantedYes"
                                [value]="true" formControlName="accessGranted"
                                [class.is-invalid]="mainForm.controls.accessGranted.touched && mainForm.controls.accessGranted.invalid">
                            <label class="form-check-label" for="accessGrantedYes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="accessGranted" id="accessGrantedNo"
                                [value]="false" formControlName="accessGranted"
                                [class.is-invalid]="mainForm.controls.accessGranted.touched && mainForm.controls.accessGranted.invalid">
                            <label class="form-check-label" for="accessGrantedNo">No</label>
                        </div>
                    </div>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.accessGranted.errors">
                        <div *ngIf="mainForm.controls.accessGranted.errors.required">Required</div>
                    </div>
                </div>


                <div class="mb-3">
                    <label for="legalFileSecure" class="form-label"
                        [class.is-invalid]="mainForm.controls.legalFileSecure.touched && mainForm.controls.legalFileSecure.invalid">Are
                        these records securely maintained by
                        Management?</label>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="legalFileSecure" id="legalFileSecureYes"
                                [value]="true" formControlName="legalFileSecure"
                                [class.is-invalid]="mainForm.controls.legalFileSecure.touched && mainForm.controls.legalFileSecure.invalid">
                            <label class="form-check-label" for="legalFileSecureYes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="legalFileSecure" id="legalFileSecureNo"
                                [value]="false" formControlName="legalFileSecure"
                                [class.is-invalid]="mainForm.controls.legalFileSecure.touched && mainForm.controls.legalFileSecure.invalid">
                            <label class="form-check-label" for="legalFileSecureNo">No</label>
                        </div>
                    </div>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.legalFileSecure.errors">
                        <div *ngIf="mainForm.controls.legalFileSecure.errors.required">Required</div>
                    </div>
                </div>


                <div class="mb-3">
                    <label for="newOrExisting" class="form-label"
                        [class.is-invalid]="mainForm.controls.newOrExisting.touched && mainForm.controls.newOrExisting.invalid">Is
                        this a new or existing {{orgId == 55 ? 'Medical ' : '' }}Legal
                        Matter?</label>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="newOrExisting" id="newOrExistingYes"
                                [value]="true" formControlName="newOrExisting"
                                [class.is-invalid]="mainForm.controls.newOrExisting.touched && mainForm.controls.newOrExisting.invalid">
                            <label class="form-check-label" for="newOrExistingYes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="newOrExisting" id="newOrExistingNo"
                                [value]="false" formControlName="newOrExisting"
                                [class.is-invalid]="mainForm.controls.newOrExisting.touched && mainForm.controls.newOrExisting.invalid">
                            <label class="form-check-label" for="newOrExistingNo">No</label>
                        </div>
                    </div>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.newOrExisting.errors">
                        <div *ngIf="mainForm.controls.newOrExisting.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="consent" class="form-label"
                        [class.is-invalid]="mainForm.controls.consent.touched && mainForm.controls.consent.invalid">Has
                        consent been obtained from a Third Party in terms of
                        Sections 48 and 72?</label>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="consent" id="consentYes" [value]="true"
                                formControlName="consent"
                                [class.is-invalid]="mainForm.controls.consent.touched && mainForm.controls.consent.invalid">
                            <label class="form-check-label" for="consentYes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="consent" id="consentNo" [value]="false"
                                formControlName="consent"
                                [class.is-invalid]="mainForm.controls.consent.touched && mainForm.controls.consent.invalid">
                            <label class="form-check-label" for="consentNo">No</label>
                        </div>
                    </div>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.consent.errors">
                        <div *ngIf="mainForm.controls.consent.errors.required">Required</div>
                    </div>
                </div>


                <div class="mb-3">
                    <label for="recordsLocation" class="form-label"
                        [class.is-invalid]="mainForm.controls.recordsLocation.touched && mainForm.controls.recordsLocation.invalid">Where
                        are the records housed?</label>
                    <input type="text" class="form-control" id="recordsLocation" formControlName="recordsLocation"
                        [class.is-invalid]="mainForm.controls.recordsLocation.touched && mainForm.controls.recordsLocation.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.recordsLocation.errors">
                        <div *ngIf="mainForm.controls.recordsLocation.errors.required">Required</div>
                    </div>
                </div>


                <div class="mb-3">
                    <label for="paiaDocumentAppealStatusId" class="form-label"
                        [class.is-invalid]="mainForm.controls.paiaDocumentAppealStatusId.touched && mainForm.controls.paiaDocumentAppealStatusId.invalid">Appeal
                        Status</label>
                    <ng-select [items]="appealStatuses" bindLabel="name" bindValue="id" id="paiaDocumentAppealStatusId"
                        formControlName="paiaDocumentAppealStatusId" placeholder="Select an appeal status"
                        [clearable]="false"
                        [class.is-invalid]="mainForm.controls.paiaDocumentAppealStatusId.touched && mainForm.controls.paiaDocumentAppealStatusId.invalid"></ng-select>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.paiaDocumentAppealStatusId.errors">
                        <div *ngIf="mainForm.controls.paiaDocumentAppealStatusId.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="paiaDocumentReferralId" class="form-label"
                        [class.is-invalid]="mainForm.controls.paiaDocumentReferralId.touched && mainForm.controls.paiaDocumentReferralId.invalid">Referrals</label>
                    <ng-select [items]="referrals" bindLabel="name" bindValue="id" id="paiaDocumentReferralId"
                        formControlName="paiaDocumentReferralId" placeholder="Select a referral" [clearable]="false"
                        [class.is-invalid]="mainForm.controls.paiaDocumentReferralId.touched && mainForm.controls.paiaDocumentReferralId.invalid"></ng-select>
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.paiaDocumentReferralId.errors">
                        <div *ngIf="mainForm.controls.paiaDocumentReferralId.errors.required">Required</div>
                    </div>
                </div>


            </div>
        </div>


        <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Important Dates</h4>


                <div class="mb-3">
                    <label for="caseOpenedDate" class="form-label"
                        [class.is-invalid]="mainForm.controls.caseOpenedDate.touched && mainForm.controls.caseOpenedDate.invalid">Date
                        case was opened</label>
                    <input type="date" class="form-control" id="caseOpenedDate" formControlName="caseOpenedDate"
                        [class.is-invalid]="mainForm.controls.caseOpenedDate.touched && mainForm.controls.caseOpenedDate.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.caseOpenedDate.errors">
                        <div *ngIf="mainForm.controls.caseOpenedDate.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="decisionProvidedDate" class="form-label"
                        [class.is-invalid]="mainForm.controls.decisionProvidedDate.touched && mainForm.controls.decisionProvidedDate.invalid">Date
                        decision was provided to the
                        requestor</label>
                    <input type="date" class="form-control" id="decisionProvidedDate"
                        formControlName="decisionProvidedDate">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.decisionProvidedDate.errors"
                        [class.is-invalid]="mainForm.controls.decisionProvidedDate.touched && mainForm.controls.decisionProvidedDate.invalid">
                        <div *ngIf="mainForm.controls.decisionProvidedDate.errors.required">Required</div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="caseClosedDate" class="form-label"
                        [class.is-invalid]="mainForm.controls.caseClosedDate.touched && mainForm.controls.caseClosedDate.invalid">Closed
                        Date</label>
                    <input type="date" class="form-control" id="caseClosedDate" formControlName="caseClosedDate"
                        [class.is-invalid]="mainForm.controls.caseClosedDate.touched && mainForm.controls.caseClosedDate.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.caseClosedDate.errors">
                        <div *ngIf="mainForm.controls.caseClosedDate.errors.required">Required</div>
                    </div>
                </div>

                <!-- <div class="mb-3">
                    <label for="renewalDate" class="form-label">Renewal Date</label>
                    <input type="date" class="form-control" id="renewalDate" formControlName="renewalDate"
                        [class.is-invalid]="mainForm.controls.renewalDate.touched && mainForm.controls.renewalDate.invalid">
                    <div class="invalid-feedback text-end" *ngIf="mainForm.controls.renewalDate.errors">
                        <div *ngIf="mainForm.controls.renewalDate.errors.required">Required</div>
                    </div>
                </div> -->



            </div>
        </div>


        <div class="card mb-3">
            <div class="card-body">
                <h4 class="card-title">Uploads</h4>


                <div class="mb-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <label for="form2FileData" class="form-label"
                            [class.is-invalid]="mainForm.controls.form2FileData.touched && mainForm.controls.form2FileData.invalid">Form
                            2</label>

                    </div>
                    <div *ngIf="currentDocument?.form2FilePath" class="d-flex align-items-center mb-2">
                        <button *ngIf="currentDocument?.form2FilePath" type="button"
                            (click)="downloadDocumentFile($event, 'Form2')"
                            class="btn btn-link d-flex justify-content-between align-items-center"><span
                                class="icon icon-view-red"></span>&nbsp;Download</button>
                        <button *ngIf="!showForm2Upload" type="button" class="btn btn-primary"
                            (click)="showForm2Upload = true;">Upload new</button>
                        <button *ngIf="showForm2Upload" type="button" class=" btn btn-primary"
                            (click)="showForm2Upload = false;">Cancel</button>
                    </div>
                    <div *ngIf="!currentDocument?.form2FilePath || showForm2Upload">
                        <input type="file" class="form-control" id="form2FileData" formControlName="form2FileData"
                            (change)="fileUpload(mainForm.controls.form2FileData, $event)"
                            [class.is-invalid]="mainForm.controls.form2FileData.touched && mainForm.controls.form2FileData.invalid">
                        <div class="invalid-feedback text-end" *ngIf="mainForm.controls.form2FileData.errors">
                            <div *ngIf="mainForm.controls.form2FileData.errors.required">Required</div>
                        </div>

                    </div>
                </div>

                <div class="mb-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <label for="letterheadFileData" class="form-label"
                            [class.is-invalid]="mainForm.controls.letterheadFileData.touched && mainForm.controls.letterheadFileData.invalid">Certified
                            Copy of data subject
                            ID/Company
                            Letterhead </label>

                    </div>

                    <div *ngIf="currentDocument?.letterheadFilePath" class="d-flex align-items-center mb-2">
                        <button *ngIf="currentDocument?.letterheadFilePath" type="button"
                            (click)="downloadDocumentFile($event, 'Letterhead')"
                            class="btn btn-link d-flex justify-content-between align-items-center"><span
                                class="icon icon-view-red"></span>&nbsp;Download</button>
                        <button *ngIf="!showLetterheadUpload" type="button" class="btn btn-primary"
                            (click)="showLetterheadUpload = true;">Upload new</button>
                        <button *ngIf="showLetterheadUpload" type="button" class=" btn btn-primary"
                            (click)="showLetterheadUpload = false;">Cancel</button>
                    </div>
                    <div *ngIf="!currentDocument?.letterheadFilePath || showLetterheadUpload">
                        <input type="file" class="form-control" id="letterheadFileData"
                            formControlName="letterheadFileData"
                            (change)="fileUpload(mainForm.controls.letterheadFileData, $event)"
                            [class.is-invalid]="mainForm.controls.letterheadFileData.touched && mainForm.controls.letterheadFileData.invalid">
                        <div class="invalid-feedback text-end" *ngIf="mainForm.controls.letterheadFileData.errors">
                            <div *ngIf="mainForm.controls.letterheadFileData.errors.required">Required</div>
                        </div>

                    </div>



                </div>

                <div class="mb-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <label for="consentFileData" class="form-label"
                            [class.is-invalid]="mainForm.controls.consentFileData.touched && mainForm.controls.consentFileData.invalid">Signed
                            consent or power of attorney
                            including
                            proof of relationship</label>

                    </div>

                    <div *ngIf="currentDocument?.consentFilePath" class="d-flex align-items-center mb-2">
                        <button *ngIf="currentDocument?.consentFilePath" type="button"
                            (click)="downloadDocumentFile($event, 'Consent')"
                            class="btn btn-link d-flex justify-content-between align-items-center"><span
                                class="icon icon-view-red"></span>&nbsp;Download</button>
                        <button *ngIf="!showConsentUpload" type="button" class="btn btn-primary"
                            (click)="showConsentUpload = true;">Upload new</button>
                        <button *ngIf="showConsentUpload" type="button" class=" btn btn-primary"
                            (click)="showConsentUpload = false;">Cancel</button>
                    </div>
                    <div *ngIf="!currentDocument?.consentFilePath || showConsentUpload">
                        <input type="file" class="form-control" id="consentFileData" formControlName="consentFileData"
                            (change)="fileUpload(mainForm.controls.consentFileData, $event)"
                            [class.is-invalid]="mainForm.controls.consentFileData.touched && mainForm.controls.consentFileData.invalid">
                        <div class="invalid-feedback text-end" *ngIf="mainForm.controls.consentFileData.errors">
                            <div *ngIf="mainForm.controls.consentFileData.errors.required">Required</div>
                        </div>
                    </div>


                </div>



            </div>
        </div>

        <div class="text-end">
            <button type="button" class="btn btn-default" routerLink="/dashboard/documents/paia">Cancel</button>&nbsp;
            <button type="submit" class="btn btn-primary">Submit</button>
        </div>
    </form>




</div>


<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Send Correspondence</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="correspondenceForm" (ngSubmit)="submitCorrespondence()">

            <div class="mb-3">
                <label for="documentCorrespondenceTypeId" class="form-label"
                    [class.is-invalid]="correspondenceForm.controls.documentCorrespondenceTypeId.touched && correspondenceForm.controls.documentCorrespondenceTypeId.invalid">Type</label>
                <ng-select [items]="documentCorrespondenceTypes" bindLabel="name" bindValue="id"
                    id="documentCorrespondenceTypeId"
                    [class.is-invalid]="correspondenceForm.controls.documentCorrespondenceTypeId.touched && correspondenceForm.controls.documentCorrespondenceTypeId.invalid"
                    formControlName="documentCorrespondenceTypeId" placeholder="Select a template"></ng-select>
                <div class="invalid-feedback text-end"
                    *ngIf="correspondenceForm.controls.documentCorrespondenceTypeId.errors">
                    <div *ngIf="correspondenceForm.controls.documentCorrespondenceTypeId.errors.required">Required</div>
                </div>

            </div>

            <div class="mb-3">
                <label for="sender" class="form-label"
                    [class.is-invalid]="(correspondenceFormSubmitted || correspondenceForm.controls.sender.touched) && correspondenceForm.controls.sender.invalid">Sender</label>
                <input type="text" class="form-control" id="sender" formControlName="sender"
                    [class.is-invalid]="(correspondenceFormSubmitted || correspondenceForm.controls.sender.touched) && correspondenceForm.controls.sender.invalid">
                <div class="invalid-feedback text-end" *ngIf="correspondenceForm.controls.sender.errors">
                    <div *ngIf="correspondenceForm.controls.sender.errors.required">Required</div>
                </div>
            </div>
            <div class="mb-3">
                <label for="name" class="form-label"
                    [class.is-invalid]="(correspondenceFormSubmitted || correspondenceForm.controls.name.touched) && correspondenceForm.controls.name.invalid">Name</label>
                <input type="text" class="form-control" id="name" formControlName="name"
                    [class.is-invalid]="(correspondenceFormSubmitted || correspondenceForm.controls.name.touched) && correspondenceForm.controls.name.invalid">
                <div class="invalid-feedback text-end" *ngIf="correspondenceForm.controls.name.errors">
                    <div *ngIf="correspondenceForm.controls.name.errors.required">Required</div>
                </div>
            </div>
            <div class="mb-3">
                <label for="email" class="form-label"
                    [class.is-invalid]="(correspondenceFormSubmitted || correspondenceForm.controls.email.touched) && correspondenceForm.controls.email.invalid">Email</label>
                <input type="text" class="form-control" id="email" formControlName="email"
                    [class.is-invalid]="(correspondenceFormSubmitted || correspondenceForm.controls.email.touched) && correspondenceForm.controls.email.invalid">
                <div class="invalid-feedback text-end" *ngIf="correspondenceForm.controls.email.errors">
                    <div *ngIf="correspondenceForm.controls.email.errors.required">Required</div>
                    <div *ngIf="correspondenceForm.controls.email.errors.email">Invalid</div>
                </div>
            </div>

            <div class="mb-3">
                <label for="documentFileData" class="form-label"
                    [class.is-invalid]="(correspondenceFormSubmitted || correspondenceForm.controls.documentFileData.touched) && correspondenceForm.controls.documentFileData.invalid">Document</label>
                <input type="file" class="form-control" id="documentFileData" formControlName="documentFileData"
                    (change)="fileUpload(correspondenceForm.controls.documentFileData, $event)"
                    [class.is-invalid]="(correspondenceFormSubmitted || correspondenceForm.controls.documentFileData.touched) && correspondenceForm.controls.documentFileData.invalid">
                <div class="invalid-feedback text-end" *ngIf="correspondenceForm.controls.documentFileData.errors">
                    <div *ngIf="correspondenceForm.controls.documentFileData.errors.required">Required</div>
                </div>
            </div>

            <div *ngFor="let attachment of correspondenceForm.controls.attachments.controls; let i = index"
                formArrayName="attachments">
                <div class="mb-3">
                    <label for="attachmentFileData" class="form-label"
                        [class.is-invalid]="(correspondenceFormSubmitted || attachment.touched) && attachment.invalid">Attachment
                        {{i+1}}</label>
                    <div class="input-group">
                        <input type="file" class="form-control" id="attachmentFileData" [formControl]="attachment"
                            (change)="fileUpload(attachment, $event)"
                            [class.is-invalid]="(correspondenceFormSubmitted || attachment.touched) && attachment.invalid">
                        <button type="button" class="btn btn-danger" (click)="removeAttachement(i)">X</button>
                    </div>
                    <div class="invalid-feedback text-end" *ngIf="attachment.errors">
                        <div *ngIf="attachment.errors.required">Required</div>
                    </div>

                </div>

            </div>
            <div class="text-end">
                <button type="button" class="btn btn-link" (click)="addAttachement()">+ Add Attachment</button>
            </div>


            <div class="text-end">
                <button type="button" class="btn btn-default" (click)="modal.dismiss()">Cancel</button>&nbsp;
                <button type="submit" class="btn btn-primary">Submit</button>
            </div>
        </form>
    </div>

</ng-template>